<template>
  <div class="nav__left">
    <a :href="logo.link" :aria-label="logo.text">
      <transition-group name="fade" mode="out-in" class="nav__logo-transition">
        <img
          v-show="!megaMenu && !scrolled"
          :src="logo.src.expanded"
          :alt="logo.text"
          class="nav__logo-expanded"
          :key="`miamiLogo`"
        />
        <img
          v-show="megaMenu || scrolled"
          :src="logo.src.collapsed"
          :alt="logo.text"
          class="nav__logo-collapsed"
          :key="`everBrighter`"
        />
      </transition-group>
    </a>
  </div>
</template>

<script>
import eventBus from '@/js/util/eventBus'

export default {
  props: {
    logo: {},
  },
  data() {
    return {
      megaMenu: false,
      scrolled: false,
    }
  },
  methods: {
    toggleMenu(menuExpanded) {
      this.megaMenu = menuExpanded
    },
    toggleScrolled(menuScrolled) {
      this.scrolled = menuScrolled
    },
  },
  mounted() {
    eventBus.$on('toggle:menu', this.toggleMenu)
    eventBus.$on('nav:desktop:opened', this.toggleMenu)
    eventBus.$on('nav:bar:scrolled', this.toggleScrolled)
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-in;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
